import enterprise from "#api/enterprise-client";

/**
 * Versão imperativa (fora de React) de `useHasFeatureFlagEnabled`, para uso em guards de rota e
 * handlers. Resolve a flag por place (respeita overrides por estabelecimento).
 *
 * Fail-safe: em qualquer erro, retorna `false` — ou seja, na dúvida a flag é tratada como desativada.
 */
export async function isFeatureFlagEnabled(
	flagKey: string,
	placeId?: string | null,
): Promise<boolean> {
	try {
		const flags = await enterprise.getFeatureFlags({ placeId: placeId ?? null });
		return !!flags?.some(flag => flag.key === flagKey && flag.enabled);
	} catch {
		return false;
	}
}
